module.exports = __webpack_public_path__ + "static/media/how_1hdpi.126238af.png";